const squashPathAndQueryString = (path, q_string) => [path, q_string].join("?");

export default squashPathAndQueryString;
